import getItem from 'owa-mail-store/lib/services/getItem';
import { ClientItem } from 'owa-mail-store';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import MimeContentType from 'owa-service/lib/contract/MimeContentType';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';

function getMessageSourceResponseShape(): ItemResponseShape {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        IncludeMimeContent: true,
    });
}

export function loadMessageSource(item: ClientItem): Promise<MimeContentType> {
    return getItem(
        item.ItemId.Id,
        getMessageSourceResponseShape(),
        null /* shapeName */,
        'V2016_06_24',
        item.MailboxInfo
    ).then(responseMessage => {
        if (responseMessage && !(responseMessage instanceof Error)) {
            return responseMessage.MimeContent;
        }
        return null;
    });
}
